rdefine('app/formular/components/BaseEditForm',['backbone','text!formular/baseform.html','text!formular/placeholder.html'],function(Backbone,template,placeholder){
    var localIncrements=0;
    return Backbone.Ribs.View.extend({
        bindings:{},
        dbindings:{
            '.card-header h2':{
                text:'model.base.name'
            },
            '.hide-required':{
                visibleCustom:'model.required'
            },
            ".toggle-switch input.required_checkbox":{
                checked:'model.required'
            },
            'input[name=label]':{
                value:'model.label'
            },
            'input[name=label_placeholder]':{
                value:'model.label_placeholder'
            },
            'input[name=invalidate]':{
                value:'model.invalidate'
            }
        },
        events:{},
        bevents:{
            "click .card-header .actions a.delete-it":"onRemove",
            "click .card-header .actions a.move-up":"onUp",
            "click .card-header .actions a.move-down":"onDown"
        },
        handlers: {
          visibleCustom:{
              get:function($el,value,key) {
                  if(!value) {
                      $el.slideUp();
                  }else{
                      $el.slideDown();
                  }
              }
          }
        },
        initialize:function(options) {
            _.extend(this.bindings,this.dbindings);
            _.extend(this.events,this.bevents);
            this.undelegateEvents();
            this.$el.addClass("base-form-el");
            this.$el.attr("draggable", "true");
            this.$el.html(Template7.compile(template)());
            this.$el.bind("dragstart", _.bind(this._dragStartEvent, this));
            this.$el.bind("dragend", _.bind(this._dragStop,this));
            this.$el.find(".toggle-switch label").attr("for","base_id_"+localIncrements);
            this.$el.find(".toggle-switch input").attr("id","base_id_"+localIncrements);
            localIncrements++;

            this.model.on("change",_.bind(function(){
                this.model.collection.trigger("change");
            },this));
            if(this.init) {
                this.init(options);
            }

            this.removeBindings();
            this.addBindings(this.bindings);

            this.delegateEvents(this.events);
            this.$el.find(".selectpicker").selectpicker();
            if(!this.model.get("required",false)) {
                this.$el.find(".hide-required").hide();
            }else{
                this.$el.find(".hide-required").show();
            }

            if(!this.model.get("invalidate") || this.model.get("invalidate").length === 0) {
               this.model.set("invalidate",this.collection.ebus.lang === "de" ? "Dieses Feld ist erforderlich":"This field is required");
            }

            setTimeout(function(){
                initFontPicker();
            },1000);


        },
        _dragStartEvent: function (e) {
            if (e.originalEvent) e = e.originalEvent;
            e.dataTransfer.effectAllowed = "copy";
            var data = this.dragStart(e.dataTransfer, e);

            window._backboneDragDropObject = null;
            if (data !== undefined) {
                window._backboneDragDropObject = data // we cant bind an object directly because it has to be a string, json just won't do
            }
        },

        dragStart: function (dataTransfer, e) {
            //console.log("Drag start",dataTransfer,e);
          //  this.collection.ebus.trigger("dragstart");
            return {o:this.model,t:'e'};
        },
        _dragStop:function() {
          //  console.log("drag stop");
          //  this.collection.ebus.trigger("dragstop");
        },
        onRemove:function(){
            this.model.collection.remove(this.model);
            return false;
        },
        onUp:function() {
            var o = 0;
            for(var key in this.collection.models) {
                this.collection.models[key].set("order",o++);
            }
            var prevKey = null;
            for(var key in this.collection.models) {
                if(this.collection.models[key] == this.model) {
                    var a = this.model.get("order");
                    var b = this.collection.models[prevKey].get("order");
                    this.collection.models[prevKey].set("order", a);
                    this.model.set("order", b);
                    this.collection.sort();
                    this.collection.trigger("change");
                    break;
                }
                prevKey = key;
            }
           /* if(oldModel) {
                oldModel.set("order",max);
                this.model.set("order",max-2);
                this.model.collection.sort();
            }*/
            return false;
        },
        onDown:function() {
            var o = 0;
            for(var key in this.collection.models) {
                this.collection.models[key].set("order",o++);
            }
            var prevKey = null;
            for(var key in this.collection.models) {
                if(prevKey && this.collection.models[prevKey] == this.model) {
                    var a = this.collection.models[prevKey].get("order");
                    var b = this.collection.models[key].get("order");
                    this.collection.models[key].set("order", a);
                    this.collection.models[prevKey].set("order", b);
                    this.collection.sort();
                    this.collection.trigger("change");
                    break;
                }
                prevKey = key;
            }
            return false;
        }
    })
});